module.exports = __webpack_public_path__ + "media/images/pokerroom/pokerstars/step4-pict03-full-15f0aa04139cfd45865d095613fef735.jpg";